import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { useMoney } from "@/context/CurrencyContext";
import { FitImage } from "./FitImage";

export const ArtCard = ({ art }) => {
  const money = useMoney();
  const img = art.image_urls?.[0];
  const priceRange = () => {
    const prices = (art.sizes || []).map(s => s.price).filter(Boolean);
    if (prices.length === 0) return "";
    const min = Math.min(...prices), max = Math.max(...prices);
    return min === max ? money(min) : `${money(min)} – ${money(max)}`;
  };
  return (
    <Link to={`/art/${art.id}`} className="group block" data-testid={`art-card-${art.id}`}>
      <div className="relative overflow-hidden bg-cream-soft aspect-[4/5]">
        {img && <FitImage src={fileUrl(img)} alt={art.title} sizes="(min-width: 1280px) 30vw, (min-width: 768px) 45vw, 100vw" imgClassName="transition-transform duration-500 group-hover:scale-[1.03]" />}
        <div className="absolute top-4 left-4 flex flex-col gap-2">
          {art.is_sold && !art.prints_only && <span className="badge-art badge-sold" data-testid="badge-sold">Sold</span>}
          {art.prints_only && <span className="badge-art badge-prints" data-testid="badge-prints">Prints Only</span>}
          {art.is_featured && <span className="badge-art badge-featured">Featured</span>}
        </div>
      </div>
      <div className="pt-5">
        <h3 className="font-serif text-2xl leading-tight mb-2 text-ink">{art.title}</h3>
        <div className="text-[11px] uppercase tracking-[0.22em] text-mute">
          {art.medium || art.category}{art.year ? ` · ${art.year}` : ""}
        </div>
        {priceRange() && (
          <>
            <div className="text-sm text-ink-soft mt-2">{priceRange()}</div>
            {art.prints_only && (
              <div className="text-[10px] text-mute mt-1" data-testid="artcard-base-price-note">Listed Base Price · shipping calculated at checkout</div>
            )}
          </>
        )}
      </div>
    </Link>
  );
};

export default ArtCard;
